$('.read-more-button').on('click', function () {

    const content = $('.read-more-content__extended');
    let more = $(this);
    let readLessData = more.data('read-less');
    let readMoreData = more.data('read-more');

     if (more.children('.read-more-button__text').text() === readMoreData) {
         more.children('.read-more-button__text').text(function () {
            return readLessData;
        });
    } else if (more.children('.read-more-button__text').text() === readLessData) {
         more.children('.read-more-button__text').text(function () {
            return readMoreData;
        });
    }

    content.slideToggle(500);



});



// WEBPACK FOOTER //
// ./scripts/routes/sections/content.js